!function(window) {

function bootstrap_navbar_functionality(options) {

	bindEvents();
	setActiveUrl();
	setSideSlide();
	

	// -- BIND SET ACTIVE PATH -- //
	function setActiveUrl() {

		// navbar selector
		var $navbar = $("#main-menu-bootstrap");
		var $lng = $("html").attr('lang');


		var currentUrl = window.location.pathname;
		// strip first and last slash
		if(currentUrl[0] === '/') {
			currentUrl = currentUrl.substring(1);
		}
		if(currentUrl[currentUrl.length-1] === '/') {
			currentUrl = currentUrl.substring(0,currentUrl.length-1);
		}

		// split by middle slashes
		var split = currentUrl.split('/');

		// remove first lng helper if not slo
		if (split && $lng != 'sl' && split.length) {
			split.splice(0, 1);
		}

		
		//set active-content to active anchors recursive
		setActiveUrlRecursive(split, $navbar);

		function setActiveUrlRecursive(aPaths, $selector) {

			// check if any paths
			if (!aPaths.length) {
				return;
			}
			// find child with selected url
			var $child = $($selector).find(`a[data-url-v-dir="${aPaths[0].toLowerCase()}"]`);
			if (!$child.length) {
				// end if no child
				return;
			}
			$child.addClass('active-content'); // add class to manipulate looks

			// remove first from array and check if we came to end
			aPaths.splice(0,1);
			if (!aPaths.length) {
				return;
			}

			//check if there is a submenu that has to be checked 
			// case when id is last 
			var $submenuOfChild = $child.siblings('.dropdown-menu'); 
			if (!$submenuOfChild.length) {
				return;
			}

			setActiveUrlRecursive(aPaths, $submenuOfChild);
		}
	}

	// -- BIND SHOW HIDE SUBMENUS -- //
	function bindEvents() {
		$('#main-menu-bootstrap li[class*="-has-children"]').on('mouseover', function(){
			// prevent this on smallscreen/mobile
			if (options.viewport.size().width < options.viewport.definition.sm) {
				return;
			}

			//show subnav
			var $li = $(this);
			if(!$li.hasClass('open')) {
				$(this).addClass('open open-fade');
			}
			
		});
		$('#main-menu-bootstrap li[class*="-has-children"]').on('mouseleave', function(ev){
			// prevent this on smallscreen/mobile
			if (options.viewport.size().width < options.viewport.definition.sm) {
				return;
			}

			// hide subnav
			var $li = $(this);	
			if($li.hasClass('open')) {
				$(this).removeClass('open open-fade');
			}
		});
		
		$("#main-menu-bootstrap a").on("click", function(ev){
			
			// povoziti je potrebno bootstrapovo funkcionalnost 
			// ki prepreči anchorje na has-children elementih
			var $anchor = $(this);
			var href = $anchor.attr('href');
			if (href && href !== '#') {
				window.location.href = href;
				return;
			}
		});

		$("#main-menu-bootstrap .submenu-navigation-mobile").on("click", function(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			var $li = $(this).closest('li');
			if ($li.hasClass('open')) {
				$li.removeClass('open open-fade');
			} else {
				$li.addClass('open open-fade');
			}
			
		})
	}

	// set sideslide if enabled
	function setSideSlide() {

		let $header = null;
		let $fixedHeader = null;
		let $slideContainer = null;
		
		// indicator if navbar already 
		// sliding so we dont overlap ourselves
		let isSliding = false;
		let last = null; // last scroll position track

		let navbarShown = false;
		let fixedHeaderShown = false;

		// calculates and sets the slide contaienr top
		// this was problematic if user scrolled and then opened
		// the slide navigation
		function setTopToSlideContainer() {


			setValues();

			$(window).resize(function() {
				// prevent jumping navbar on resize because content length is changing
				isSliding = true;
				setTimeout(() => isSliding = false, 50);
				setValues();
				
				// need to show/display when we go to mobile/desktop view
				showHideFixedHeader(true);
			});

			function setValues() {
				var height = $header.outerHeight();
				$slideContainer.css('top', `${height}px`);
			}
		}

		// bind scroll event to hide / show top header
		function hideShowSlideTopMenu() {

			$(window).on('scroll', function (ev) {
				if (options.viewport.size().width < options.viewport.definition.sm) {
					showHideFixedHeader();	
				}
			});
		}


		// actual funciton that maniplates display/hiding of top header
		function showHideFixedHeader(onResize = false) {
			if (!onResize) {
				const current = $(window).scrollTop();
				if (!isSliding && !navbarShown) {
					if (current > last && current > $header.outerHeight()) {
						hideHeader(current);
					} else if (current < last) {
						showHeader(current);
					}
				}
				if (!isSliding && !navbarShown) {
					last = current;
				}
			} else {
				if (!isSliding) {
					if (fixedHeaderShown && options.viewport.size().width > options.viewport.definition.sm) {
						hideHeader(false);
					} else if (fixedHeaderShown && options.viewport.size().width <= options.viewport.definition.sm) {
						showHeader(false);
					}
				}
				
			}


			// hides the header
			function hideHeader(current = null, resize = false) {
				isSliding = true;
				$fixedHeader.slideUp(function() {
					
					isSliding = false;
					if (!resize) {
						last = current;
						fixedHeaderShown = false;
					}
				});
			}

			// shows header
			function showHeader(current = null, resize = false) {
				isSliding = true;
				$fixedHeader.slideDown(function() {
					isSliding = false;
					if (!resize) {
						last = current;
						fixedHeaderShown = true;
					}
				});
			}
			
		}

		// if target slide option was set in ads
		if ($('[data-target-side]').length) {

			$header = $('header');
			$slideContainer = $('.collapse-side');

			last = $(window).scrollTop(); // last scroll position track

			// we are cloning and appending fixed else its jumps
			$fixedHeader = $header.clone();
			$fixedHeader.addClass('fixed-top mobile-only');
			$fixedHeader.hide();
			$fixedHeader.insertBefore($header);

			// remove extra navbar because it leads to wrong stuff
			$('header.fixed-top.mobile-only .navbar').remove(); 

		
			showHideFixedHeader();
			setTopToSlideContainer();
			hideShowSlideTopMenu();

			var slideBtn = $('[data-target-side]');
			var targetOne = slideBtn.attr('data-target');
			var targetTwo = slideBtn.attr('data-target-side');
			var $hamburger = $('.hamburger');
			var $body = $('body');

			slideBtn.click(function(event){
				$(targetOne).toggleClass('in');
				$(targetTwo).toggleClass('out');
				$hamburger.toggleClass('is-active');
				$body.toggleClass('disable-vertical-scroll');
				navbarShown = $body.hasClass('disable-vertical-scroll');
			});
		} else {
			// normal navigation is all set by bootstrap
			// here we animate the hamburger btn
			$(".hamburger").on("click", function() {
				$(this).toggleClass('is-active');
			})
		}

		
	
	}

}
module.exports = bootstrap_navbar_functionality;
window.bootstrap_navbar_functionality = bootstrap_navbar_functionality;
}.call(window, window);